import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolderInside: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMoveFolderInside"><Path d="M19.2803 14.7803L17.5605 16.5H22.75V18H17.5605L19.2803 19.7197L18.2197 20.7803L14.6895 17.25L18.2197 13.7197L19.2803 14.7803Z" fill="currentColor"/><Path d="M12.4014 6H22V15H21.5527L18.1514 11.5986L12.5 17.25L14.9277 20H2V3H10.4014L12.4014 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMoveFolderInside;
